import { ReactElement } from 'react';
import { IBaseModel, IListFetchParams, BaseRepository } from '../../../common';
import { Icon } from '@jobcost-monorepo/ui';
import { useTranslation } from '@jobcost-monorepo/i18n';
import React from 'react';

interface Props<T extends IBaseModel, Q extends IListFetchParams> {
  repository: BaseRepository<T, Q>;
}

const GridHeader = <T extends IBaseModel, Q extends IListFetchParams>({
  repository,
}: Props<T, Q>): ReactElement => {
  const { t } = useTranslation(repository.moduleName?.toLocaleLowerCase());
  return (
    <thead>
      <tr className="w-full">
        {repository.gridFieldsOptions
          .filter((col) => col.visible)
          .sort((col1, col2) => col1.position - col2.position)
          .map((col) => {
            return (
              <th key={String(col.linkedField)} align={col.align}>
                <div className="flex items-center space-x-4 p-3 max-h-12 overflow-hidden">
                  <span className="line-clamp-1">
                    {t(`grid.${String(col.linkedField)}`)}
                  </span>
                  {col.sortable && (
                    //TODO implementare logica di ordinamento
                    <Icon
                      iconName={col.sortable ? 'chevronDown' : 'chevronUp'}
                    />
                  )}
                </div>
              </th>
            );
          })}
      </tr>
    </thead>
  );
};

export default GridHeader;
